import React from 'react';
import { StyleSheet, View } from './components/base_components';
import { BrowserRouter, Route, Switch } from 'inferno-router';

import ModalDialog from './components/dialogs/modal_dialog';
import ProgressOverlay from './components/overlays/progress_overlay';

import ClientVersionScreen from './client_version_screen';
import DeviceScreen from './device_screen';
import DeviceEditScreen from './device_edit_screen';
import DeviceVolumeScreen from './device_volume_screen';
import FileReportScreen from './file_report_screen';
import HomeScreen from './home_screen';
import LoginScreen from './login_screen';
import LogoutScreen from './logout_screen';
import NotFoundScreen from './not_found_screen';
import OrgEditScreen from './org_edit_screen';
import OrgListScreen from './org_list_screen';
import OrgUserEditScreen from './org_user_edit_screen';
import ToolScreen from './tool_screen';
import UploaderScreen from './uploader_screen';
import UserEditScreen from './user_edit_screen';
import UserListScreen from './user_list_screen';
import VolumeScreen from './volume_screen';
import VolumeEditScreen from './volume_edit_screen';

import UserStore from './stores/user_store';

const styles = StyleSheet.create({
  app: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'transparent',
  },
});

type Props = {
  match: any;
};
type State = {
  is_ready: boolean;
  is_logged_in: boolean;
};

export default class App extends React.PureComponent<Props, State> {
  state = {
    is_ready: false,
    is_logged_in: false,
  };
  componentDidMount() {
    UserStore.addChangeListener(this._onUserChange);
    UserStore.init();
  }
  componentWillUnmount() {
    UserStore.removeChangeListener(this._onUserChange);
  }
  _onUserChange = () => {
    this.setState({
      is_ready: UserStore.isReady(),
      is_logged_in: UserStore.isLoggedIn(),
    });
  };

  render() {
    const { is_ready, is_logged_in } = this.state;

    let content = null;
    if (!is_ready) {
      content = <ProgressOverlay />;
    } else if (!is_logged_in) {
      content = <LoginScreen />;
    } else {
      content = (
        <BrowserRouter>
          <Switch>
            <Route exact path='/' component={HomeScreen} />
            <Route path='/volume/:volume_id/:path*' component={VolumeScreen} />
            <Route
              path='/device/:device_id/volume/:volume_id'
              component={DeviceVolumeScreen}
            />
            <Route path='/device/:device_id' component={DeviceScreen} />
            <Route exact path='/logout' component={LogoutScreen} />
            <Route
              exact
              path='/admin/client_version'
              component={ClientVersionScreen}
            />
            <Route exact path='/admin/org' component={OrgListScreen} />
            <Route exact path='/admin/org/:org_id' component={OrgEditScreen} />
            <Route
              exact
              path='/admin/org/:org_id/user/:user_id'
              component={OrgUserEditScreen}
            />
            <Route exact path='/admin/user' component={UserListScreen} />
            <Route path='/admin/user/:user_id' component={UserEditScreen} />
            <Route
              path='/admin/device/:device_id'
              component={DeviceEditScreen}
            />
            <Route
              path='/admin/volume/:volume_id'
              component={VolumeEditScreen}
            />
            <Route path='/admin/file_report' component={FileReportScreen} />
            <Route exact path='/tool' component={ToolScreen} />
            <Route exact path='/uploader' component={UploaderScreen} />
            <Route path='*' component={NotFoundScreen} />
          </Switch>
        </BrowserRouter>
      );
    }

    return (
      <View style={styles.app}>
        {content}
        <ModalDialog />
      </View>
    );
  }
}
